import React from 'react';
import PropTypes from 'prop-types';

import style from './style.scss';

const ProgressBar = ({ steps, currentStep, isDisabled }) => (
  <div className={style.progressBar}>
    <div className={style['arrow-steps']}>
      {steps.map((step, i) => (
        <div
          key={i}
          className={`${style.step} ${i === currentStep && !isDisabled ? style.current : ''} ${i < currentStep ? style.previous : ''}`}
        >
          <span>{step.label}</span>
        </div>
      ))}
    </div>
  </div>
);

ProgressBar.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.object).isRequired,
  currentStep: PropTypes.number.isRequired,
  isDisabled: PropTypes.bool,
};

ProgressBar.defaultProps = {
  isDisabled: false,
};

export default ProgressBar;



// WEBPACK FOOTER //
// ./src/components/ProgressBar/index.js